import { put } from "redux-saga/effects";
import { register } from "../../Services";

export function* registerSaga(action) {
  const payload = action.payload;
  try {
    const res = yield register(payload);
    yield put({ type: "REQ_REGISTER_SUCCEEDED", data: res });
  } catch (e) {
    yield put({ type: "REQ_REGISTER_FAILED", errData: e });
  }
}
